"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewAvailabilityButton = void 0;
var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));
var _react = _interopRequireDefault(require("react"));
var _intl = require("@kyruus/intl");
var _globals = require("../../../../lib/constants/globals");
var _messages = _interopRequireDefault(require("../../../../lib/constants/messages"));
var _styles = require("../../styles");
/**
 * Renders a button to view availability for a provider.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.providerId - The ID of the provider.
 * @param {Function} props.onClickShowAvailability - The function to handle the click event for showing availability.
 * @param {boolean} props.shouldDisplayAvailability - Indicates whether availability should be displayed.
 * @param {Array} props.locations - The locations associated with the provider.
 * @param {boolean} props.disabled - Indicates whether the button is disabled.
 * @param {Function} props.track - The function to track the event.
 * @returns {JSX.Element|null} The rendered ViewAvailabilityButton component.
 */
const ViewAvailabilityButton = _ref => {
  let {
    providerId: provider_id,
    onClickShowAvailability,
    shouldDisplayAvailability,
    locations,
    disabled,
    track
  } = _ref;
  /**
   * Checks if any of the locations have slots available.
   */
  const hasSlots = (0, _some.default)(locations).call(locations, location => !!location.slots);
  if (!shouldDisplayAvailability || !hasSlots) {
    return null;
  }
  const handleClick = e => {
    onClickShowAvailability(e);
    track(_globals.LOGGING.MESSAGE.VIEW_AVAILABILITY, {
      provider_id
    });
  };
  return /*#__PURE__*/_react.default.createElement(_styles.ViewAvailButton, {
    mode: "ghost",
    onClick: handleClick,
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.viewAvailabilityProviderTile));
};
exports.ViewAvailabilityButton = ViewAvailabilityButton;
ViewAvailabilityButton.__docgenInfo = {
  "description": "Renders a button to view availability for a provider.\n\n@component\n@param {Object} props - The component props.\n@param {string} props.providerId - The ID of the provider.\n@param {Function} props.onClickShowAvailability - The function to handle the click event for showing availability.\n@param {boolean} props.shouldDisplayAvailability - Indicates whether availability should be displayed.\n@param {Array} props.locations - The locations associated with the provider.\n@param {boolean} props.disabled - Indicates whether the button is disabled.\n@param {Function} props.track - The function to track the event.\n@returns {JSX.Element|null} The rendered ViewAvailabilityButton component.",
  "methods": [],
  "displayName": "ViewAvailabilityButton"
};